import React, { Component } from "react";

import { Button } from "@appcues/component-library";
import SatisfactionSurveyCard from "components/SatisfactionSurveys/SatisfactionSurveyCard";

class ContentSummary extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { questionOne, questionTwo, updateSatisfaction } = this.props;

    return (
      <SatisfactionSurveyCard
        disableHover
        className="satisfaction-form-card"
        header="Content"
      >
        <div className="satisfaction-card-top">
          <hr />
          <p>
            <b>Survey:</b> {questionOne}
          </p>
          <p>
            <b>Feedback:</b> {questionTwo}
          </p>
          <Button
            onClick={() => {
              updateSatisfaction({ currentStep: 1, isTestMode: false });
            }}
            className="button"
          >
            Edit
          </Button>
        </div>
      </SatisfactionSurveyCard>
    );
  }
}

export default ContentSummary;
